import script from "./MonitorPianificazioni.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitorPianificazioni.vue?vue&type=script&setup=true&lang=ts"

import "./MonitorPianificazioni.vue?vue&type=style&index=0&id=71918d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71918d2a"]])

export default __exports__